export namespace UiModels {
  export interface ContactFormValue {
    name: string;
    phones: string[];
    emails: string[];
    position: string;
    contactOnWeekend: boolean;
    contactOnShabbat: boolean;
  }

  export enum PreloaderColor {
    white,
    blue,
    gray,
    red
  }

  export enum UIInputStyle {
    labelInside,
    labelOutside,
    noLabel,
    noLabelThick,
    labelWithIcon
  }

  export enum DayOfWeek {
    monday,
    tuesday,
    wednesday,
    thursday,
    friday,
    saturday,
    sunday,
  }

  export enum UiButtonStyle {
    red,
    default,
    gray,
    green,
  }

  /**
   * @deprecated use  LiveKitModels.LiveKitServerRegion instead
   */
  export enum Region {
    US_EAST = 'us-east',
    US_WEST = 'us-west',
    ISRAEL = 'israel',
  }

  export enum ConfirmModalType {
    delete,
    leave,
  }

  export enum UiAutocompleteTemplate {
    string,
    user,
  }

  export enum UiUptimeBarColors {
    primary,
    red,
    pink,
    gray,
    green,
    offline,
    online,
    green50
  }

  export enum UiUserSettingsDateType {
    timeSec,
    time, // time only
    mdTime, //month day time
    mdyTime, // month day year time
    mdy, //month day year
    mdyTimeSec, // month day year time seconds
    mdyTimeSecMs, // month day year time seconds milliseconds (2 digits)
  }

  export enum UiUserSettingsDateFormat {
    ddMMyy,
    MMddyy,
  }

  export enum UiCalendarPickerType {
    RELATIVE,
    ABSOLUTE,
  }

  /**
   * @deprecated
   */
  export enum ThumbnailImageSelectorType {
    Camera,
    Alert
  }

  export enum AuthResponseFromUrl {
    EmailVerificationRequired,
    IpRulesRequired,
    LoginRequired,
    Success,
    WrongPassword,
    MFAWrongCode,
    UserBlocked,
    InviteNotYours
  }

  export interface UiChipSelectChange {
    value: string;
    selected: boolean;
  }

  export interface UiChipOption {
    name: string;
    value: string;
  }

  export const openDialogByParams = {
    createArchive: 'createArchive',
    createTimelapse: 'createTimelapse',
    createEntrance: 'createEntrance',
    createYoutube: 'createYoutube',
    openLiveView: 'openLiveView',
    createVariable: 'createVariable',
    createHttpRequest: 'createHttpRequest',
    createMicrosoftTeamsChannel: 'createChannel',
    createMFA: 'createMFA',
    changeEmail: 'changeEmail',
    changePhone: 'changePhone',
    changeDateSettings: 'changeDateSettings',
    changeAutoLogout: 'changeAutoLogout',
    changeUsername: 'changeUsername',
    changeLanguage: 'changeLanguage',
    changeTheme: 'changeTheme',
    changeWeeklySubscription: 'changeWeeklySubscription',
    changeSessionSettings: 'changeSessionSettings',
    inviteUsers: 'inviteUsers',
    pendingInvites: 'pendingInvites',
    inviteSupport: 'inviteSupport',
    joinPersonGroup: 'joinPersonGroup',
    joinVehicleGroup: 'joinVehicleGroup',
    addVehicles: 'addVehicles',
    addVehiclesFromCsv: 'addVehiclesFromCsv',
    createBuilding: 'createBuilding',
    addPersonFromFile: 'addPersonFromFile',
    openGenerateKey: 'openGenerateKey',
    openPrivateStorageOption: 'openPrivateStorageOption',
    openPrivateStorageTest: 'openPrivateStorageTest',
    openGenerateOAuth2Credential: 'openGenerateOAuth2Credential',
    openInstallLumana: 'openInstallLumina',
    openInstallImmix: 'openInstallImmix',
    openInstallFlir: 'openInstallFlir',
    assignDoorToCamera: 'assignDoorToCamera',
    editSublocation: 'editSublocation',
    addCameraManually: 'addCameraManually',
    openIpScan: 'openIpScan',
    changeDevicePageView: 'changeDevicePageView',
    changeDeviceEmails: 'changeDeviceEmails',
    createHttpRequestKey: 'createHttpRequestKey',
    createTag: 'createTag',
    editTag: 'editTag',
    addEmailToSales: 'addEmailToSales',
    addEmailToOrgCreator: 'addEmailToOrgCreator',
    createShelf: 'createShelf',
    globalSearchSettings: 'globalSearchSettings',
    addPartitionZones: 'addPartitionZones',
    defineVacation: 'defineVacation',
    addAccountContact: 'addAccountContact',
    addOrganizationContact: 'addOrganizationContact',
    createAccount: 'createAccount',
    createContactGroup: 'createContactGroup',
    editAccountContact: 'editAccountContact',
    editContactGroup: 'editContactGroup',
    manageContactGroupMembers: 'manageContactGroupMembers',
    sendNotificationTemplate: 'sendNotificationTemplate',
    previewNotificationRecipients: 'previewNotificationRecipients',
    createPartition: 'createPartition',
    createFirstPartition: 'createFirstPartition',
    createZoneRegion: 'createZoneRegion',
    editZoneRegion: 'editZoneRegion',
    openZoneRegionsPicker: 'openZoneRegionsPicker',
    createWorkflowWebhook: 'createWorkflowWebhook',
    editWorkflowWebhook: 'editWorkflowWebhook',
    createPolicy: 'createPolicy',
    updatePolicy: 'updatePolicy',
    createCase: 'createCase',
    addCasePeople: 'addCasePeople',
    editCase: 'editCase',
    createCaseCategory: 'createCaseCategory',
    editCaseCategory: 'editCaseCategory',
    addCaseFile: 'addCaseFile',
    editCaseFile: 'editCaseFile',
    annotateCaseClip: 'annotateCaseClip',
    openRateLimitStrategy: 'openRateLimitStrategy',
    openRateLimitDynamic: 'openRateLimitDynamic',
    showDefaults: 'showDefaults',
    createEdgeAgentApiKey: 'createEdgeAgentApiKey',
    openSupportAccess: 'openSupportAccess',
    addPanicContact: 'addPanicContact',
    editPanicContact: 'editPanicContact',
    createPanicContactGroup: 'createPanicContactGroup',
    editPanicContactGroup: 'editPanicContactGroup',
    managePanicContactGroupMembers: 'managePanicContactGroupMembers',
    createPanicHttpRequest: 'createPanicHttpRequest',
    editPanicHttpRequest: 'editPanicHttpRequest',
    viewPanicContactsActivityLogParams: 'viewPanicContactsActivityLogParams',
    viewPanicAlertDeliverySteps: 'viewPanicAlertDeliverySteps',
    viewPanicUserActivityLogContext: 'viewPanicUserActivityLogContext',
    createPanicManualEvent: 'createPanicManualEvent',
    editPanicManualEvent: 'editPanicManualEvent',
  };

}
